import React from "react";
import {
  StarFillExtraLarge,
  StarOutlineExtraLarge,
} from "../../assets/SvgIcons";

/**
 * @author
 * @function BasicInfo
 **/

export const BasicInfo = (props) => {
  const review = { rating: 3 };
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 ">
      <div className="flex flex-col justify-center items-center mt-8">
        <div className="h-[150px] w-[200px] bg-white rounded  border-2 border-gray-400 flex justify-center items-center">
          <div
            style={{
              backgroundImage: `url(https://wristlink.s3.me-south-1.amazonaws.com/1478195818-aleeha-logo.png)`,

              backgroundPosition: "center",
              backgroundSize: "cover",
              height: 60,
              width: 150,
            }}
          ></div>
        </div>
        <div className="my-8">
          <h2 className="lg:text-2xl md:text-xl sm:text-lg font-bold text-[#0297B2]">
            Aleeha Watch BD
          </h2>
        </div>
        <div className="max-w-[720px] mx-auto">
          <p>
            Luxury Time Global continues to be the premier online wholesaler and
            discounter of luxury watches since 2008. We pride ourselves in
            delivering the lowest prices with an uncompromising effort to exceed
            customer expectations! Just take a look at our reviews! We are very
            passionate about horology and deliver the best experience in the
            marketplace because we truly care about finding you that special
            timepiece. Our incredible focus is, and always has been on trust and
            relationships with our clients and their needs.
          </p>
          <br />
          <br />
          <p>
            We specialize in unworn Rolex, Patek Philippe, Audemars Piguet, IWC,
            Cartier, Breitling, Omega and many more brands.
            <br />
            <br />
            All of our watches are guaranteed 100% authentic and backed by a
            100% satisfaction guarantee. We have 1000s of satisfied clients
            worldwide, and continue to work to find that special timepiece that
            suits your needs at the best possible price.
            <br />
            <br />
            We are also buyers for modern Rolex, AP and Patek, and will offer
            the most aggressive quotes worldwide. Payment methods include Bank
            Wire and Chrono24 Trusted Checkout. We are NOT an authorized dealer
            for the any of the brands we sell.
            <br />
            <br />
            Please don't hesitate to contact us at: +1-835-210-4858 -or- email
            sales@luxurytimeglobal.com
            <br />
            <br />
            Follow us on Instagram: luxurytimeglobal BBB, Member; A+
            Accreditation State Registered Wholesaler/Retailer of luxury
            timepieces in PA and FL.
          </p>
        </div>

        <div className="mt-8 mb-2.5">
          <h2 className="lg:text-2xl md:text-xl sm:text-lg font-semibold ">
            Reviews
          </h2>
        </div>

        <div className="max-w-[720px] mx-auto mb-8">
          <div className="flex items-center justify-center gap-0.5 text-secondary mx-auto">
            {[...Array(review?.rating)].map((_, index) => (
              <p key={index} className="py-1.5 px-0.5 text-[36px]">
                {StarFillExtraLarge}
              </p>
            ))}
            {[...Array(5 - review?.rating)].map((_, index) => (
              <p key={index} className="py-1.5 px-0.5 text-[36px]">
                {StarOutlineExtraLarge}
              </p>
            ))}
          </div>
          <p>5.0 out of 5 stars | Reviews: 797 </p>
        </div>
      </div>
    </section>
  );
};
